exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emptyText__text___2MjIj {\n  padding: 0;\n  margin-inline: 15px;\n  text-align: center; }\n\n@media (max-width: 576px) {\n  .emptyText__text___2MjIj {\n    text-align: center; } }\n", ""]);

// exports
exports.locals = {
	"text": "emptyText__text___2MjIj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SavedSearchPage/EmptyText/emptyText.scss
// module id = 5056
// module chunks = 6